import { css } from '@emotion/react';
import { Fieldobject } from './_mixin.mixin';


export default $ => css`
  ${new Fieldobject('personalNonCCD-dct').include($, css`
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(5, auto)',
    gridColumnGap: '0px',
    gridRowGap: '0px',

    '.file-field': {
      textAlign: 'center',
      '> a': {
        width: '100%',
        maxWidth: '280px',
      },
      margin: '0',
    },

    '.banco': { gridColumn: '1' },
    '.puesto': { gridColumn: '2' },
    '.safi': { gridColumn: '3' },
    '.title': { gridRow: '1', alignSelf: 'flex-end', justifySelf: 'center' },
    '.tarjetaFirma': { gridRow: '2' },
    '.informeInversionista': { gridRow: '3' },
    '.contratoMarco': { gridRow: '4' },
    '.contratoCuenta': { gridRow: '5' },
    '.cartaAutorizacionCuenta': { gridRow: '5' },
    '.formularioCliente': { gridRow: '6' },
    '.formularioW8Ben': { gridRow: '7' },
    '.formularioW9': { gridRow: '7' },
    '.formularioMoneyline': { gridRow: '8' },
    '.formularioSujetoObligado': { gridArea: '9 / 1 / 9 / 1' },
    '.solicitudPrestamoDL': { gridArea: '10 / 1 / 10 / 1' },
  `)}

  ${new Fieldobject('personalNonCCD-upload').include($, css`
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(5, auto)',
    gridColumnGap: '0px',
    gridRowGap: '0px',

    '.file-field': {
      '> .file-input': {
        flexWrap: 'nowrap',
        '> .input-group-text': {
          width: 'auto',
          flexShrink: '100',
          maxWidth: '15em',
        },
        '.btn': {
          whiteSpace: 'nowrap',
        },
      },
    },
  `)}
`;
